import React, { useEffect, useState } from 'react';
import { Sun, Moon, Sunrise, CheckCircle } from 'react-feather';
import { loadAppearance, saveAppearance } from '../../Resources/appearance';
import './AppearanceSettings.css';
export default function AppearanceSettings() {
  const [mode, setMode] = useState(localStorage.getItem('nextstock-appearance-mode') || 'auto');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    let live = true;
    let changedSinceLoad = false;
    const syncFromHeader = (event) => {
      changedSinceLoad = true;
      const next = event?.detail?.mode || localStorage.getItem('nextstock-appearance-mode') || 'auto';
      if (live && ['light', 'dark', 'auto'].includes(next)) {
        setMode(next);
        setError('');
      }
    };
    window.addEventListener('nextstock-appearance-changed', syncFromHeader);
    loadAppearance().then(result => {
      if (live && !changedSinceLoad) {
        setMode(['light', 'dark', 'auto'].includes(result?.mode) ? result.mode : 'auto');
        setError('');
      }
    }).catch(() => {
      if (live && !changedSinceLoad) {
        setMode(localStorage.getItem('nextstock-appearance-mode') || 'auto');
        setError('Could not reach the server. Using your current theme until connection is restored.');
      }
    });
    return () => {
      live = false;
      window.removeEventListener('nextstock-appearance-changed', syncFromHeader);
    };
  }, []);
  async function choose(next) {
    if (busy || next === mode) return;
    setBusy(true); setError('');
    try { await saveAppearance(next); setMode(next); }
    catch { setError('Unable to save your preference. Please try again.'); }
    finally { setBusy(false); }
  }
  const choices = [
    { id: 'light', title: 'Light Mode', caption: 'Bright, crisp and clear for daytime.', Icon: Sun },
    { id: 'dark', title: 'Dark Mode', caption: 'Softer contrast for evening viewing.', Icon: Moon },
    { id: 'auto', title: 'Auto Mode', caption: 'Light 5 AM–6 PM · Dark 6 PM–5 AM.', Icon: Sunrise }
  ];
  return <section className="ns-appearance-section" aria-label="Appearance settings">
    <div className="ns-appearance-heading"><div><h2>✦ Appearance</h2><p>Make Next Stock feel right, day or night.</p></div>{busy && <span className="ns-appearance-saving">Saving…</span>}</div>
    <div className="ns-appearance-grid">{choices.map(({ id, title, caption, Icon }) => <button key={id} type="button" disabled={busy} onClick={() => choose(id)} className={`ns-appearance-choice ${mode === id ? 'selected' : ''}`} aria-pressed={mode === id}>
      <div className={`ns-appearance-preview preview-${id}`}>
        {id === 'auto' ? <div className="ns-auto-scene" aria-hidden="true"><div className="ns-auto-sky ns-auto-day"><span className="ns-auto-sun"/><span className="ns-auto-cloud"/><span className="ns-auto-horizon"/></div><div className="ns-auto-sky ns-auto-night"><span className="ns-auto-moon"/><span className="ns-auto-star star-one"/><span className="ns-auto-star star-two"/><span className="ns-auto-star star-three"/><span className="ns-auto-horizon"/></div><span className="ns-auto-transition"/></div> : <><div className="ns-preview-sidebar"/><div className="ns-preview-main"><div className="ns-preview-header"/><div className="ns-preview-bars"><i/><i/><i/></div><div className="ns-preview-cards"><i/><i/></div></div></>}
        {id !== 'auto' && <div className="ns-preview-particles" aria-hidden="true"><i/><i/><i/><i/><i/></div>}
      </div>
      <div className="ns-appearance-choice-title"><Icon size={18}/><strong>{title}</strong>{mode === id && <CheckCircle size={17} className="ns-appearance-selected"/>}</div><span>{caption}</span>
    </button>)}</div>
    <p className="ns-appearance-footnote">Auto follows your local time zone. Your preference is saved to your account and synced across devices.</p>
    {error && <p className="ns-appearance-error" role="alert">{error}</p>}
  </section>;
}
